/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-09-05 09:39:14
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-08 15:30:18
 * @FilePath: \land_informatization\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Map from '../views/Map.vue'
import Home from '../views/Home.vue'
import Laryer from '../views/Laryer.vue'
import personnel from '../views/personnel.vue'
import Land from '../views/Land.vue'
import institution from '../views/institution.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/map',
        name: 'Map',
        component: Map
      },
      {
        path: '/laryer',
        name: 'Laryer',
        component: Laryer
      },
      {
        path: '/personnel',
        name: 'personnel',
        component: personnel
      },
      {
        path: '/Land',
        name: 'Land',
        component: Land
      },
      {
        path: '/institution',
        name: 'institution',
        component: institution
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
